import React from "react";
import ReactDOM from "react-dom";
import deleteOrderImg from "../images/delete-order.png";

function DeleteItemModal({modal, setModal, title, text, handleDelete}) {
 
  return ReactDOM.createPortal(
    <React.Fragment>
      <div
        className={"modal fade " + (modal ? "show " : "")}
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={modal ? { display: "block" } : { display: "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header px-4 border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => setModal(false)}
              ></button>
            </div>
            <div className="modal-body py-0 pb-4">
              <div className="row justify-content-center text-center">
                <div className="col-sm-8">
                  <img src={deleteOrderImg} className="img-fluid" />
                  <h5 className="fs-20 fw-semibold mt-4" id="exampleModalLabel">{title}</h5>
                  <p className="fs-16 mb-4">{text}</p>
                  <div className="row justify-content-center">
                    <div className="col-sm-7">
                      <a onClick={handleDelete}
                        role="button" className="btn btn-sm btn-danger d-flex align-items-center px-2 fw-medium rounded-3 justify-content-center">Delete</a>
                      <a onClick={() => setModal(false)} role="button" className="btn btn-sm d-flex align-items-center px-2 fw-medium rounded-3 justify-content-center">No</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modal ? <div className="modal-backdrop fade show" /> : ""}
    </React.Fragment>,
    document.getElementById("modal-root")
  );
}
export default DeleteItemModal;
